var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registerSetResult"},[_c('i',{staticClass:"el-icon-success"}),_c('font',[_vm._v("注册成功")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goback}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }